export default {"src":"/_next/static/media/loading_bg.c1c046e7.PNG","height":874,"width":1873,"blurWidth":0,"blurHeight":0};